<template>
  <ProductSlider :config="config" />
</template>

<script>
import ProductSlider from "../../components/ProductSlider/ProductSlider.vue";

export default {
  name: "app",
  components: {
    ProductSlider
  },
  data() {
    return {
      config: JSON.parse(this.$options._parentVnode.data.props.config),
    };
  }
};
</script>
